import agent from "../../../api/agent";
export const list = (pagerInputModel) =>  agent.requests.post(`/Role/getList`, pagerInputModel);
export const create = (Role)        => agent.requests.post(`/Role/create`, Role);
export const update = (Role)        => agent.requests.post(`Role/update`, Role);
export const deleteRole = (Role)  => agent.requests.post(`Role/delete`, Role);

